export default "__VITE_ASSET__Bi6wUAfR__"